<template>
  <div>
    <!-- A4 SPREADSHEET (LANDSCAPE, PORTRAIT) -->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-spreadsheet-portrait-page':'a4-spreadsheet-landscape-page':field.temp_prop.orientation==0?'a5-spreadsheet-portrait-page':'a5-spreadsheet-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0,0,0,0.13);"
    >
      <div class="print-template" :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':(field.temp_prop.font_color.hex||'#000'),'background':(field.temp_prop.bg_color.show&&field.temp_prop.bg_color.value.hex||'#000')}">
        <!-- Header margin top value as height -->

        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          v-if="field.header_prop.show_doc_title"
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <div class="invoice-layout" :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'font-size':(field.temp_prop.font_size||8)+'pt'}">
            <!-- Page Heading -->
            <div class="invoice-top-heading">
              <h5
                class="text-center"
                :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
                style="margin-bottom:0 !important;margin-top:0.1in;position:relative;word-break:break-word"
              >
                {{field.header_prop.doc_title}}
                <span
                  v-show="showprintlabel && printlabel != ''"
                  style="position:absolute;right:0;padding:2px 4px;border:2px solid #929292;color:#000;font-size:9pt;margin-right:5px"
                >{{ printlabel }}</span>
              </h5>

              <div
                :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}"
                v-if="field.header_prop.show_inv_no"
                class="text-center"
                style="margin-bottom:1px;font-weight:500;word-break:break-word"
              ><span v-if="field.header_prop.hasOwnProperty('doc_no')&&field.header_prop.doc_no.show">{{field.header_prop.doc_no.label}}</span>{{ $AppDetails.financial_year +'/'+list.header_details.crdt_no }}</div>
            </div>
            <!-- First Block -->
            <div
              class="invoice-first-block spreadsheet-layout-pad"
              style="display:flex;justify-content: space-between;"
              :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
            >
              <!-- Organization Details -->
              <div style="width:30% !important;word-break:break-word" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                <div
                  v-if="field.header_prop.show_org_name"
                  :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                  style="margin-bottom:1px;font-weight:500;word-break:break-word"
                >{{ org_details.comp_name }}</div>

                <div v-if="field.header_prop.show_org_addr" class="custom-invoice-address">
                  <p>{{ org_details.addr_line_1 }}</p>
                  <p>{{ org_details.addr_line_2 }}</p>
                  <p>{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</p>
                  <p>
                    {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                    {{ org_details.org_pincode }}
                  </p>
                  <p>{{field.header_prop.phone}}: {{ org_details.phone_no }}</p>
                  <p class="mb-0" href="mailto:#">{{ org_details.org_mail }}</p>
                  <p
                    v-if="org_details.gst_type != 3 && org_details.gst_no != ''"
                    style="margin-bottom:0px;"
                  >GSTIN: {{ org_details.gst_no }}</p>
                </div>
              </div>

              <!-- Organization Logo -->
              <div>
                <!-- Max width for Logo Block -->

                <!-- Logo Image -->
                <img
                  v-if="field.header_prop.show_logo && org_details.org_logo != null && org_details.org_logo  != ''"
                  v-bind:src="imageSrc"
                  :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                  style="max-width:300px;max-height:183.05px;padding-bottom:5px !important"
                />
              </div>
            </div>
            <!-- End of First Block -->
            <div  :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div>

            <div v-if="field.header_prop.doc_inv_tag.show"></div>
            <!-- End of Second Block -->
            <!-- Third Block-->
            <div
              v-if="field.header_prop.doc_inv_tag.show"
              class="invoice-third-block spreadsheet-layout-pad"
              style="margin:3px 0;"
              :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
            >
              <table class="custom-invoice-details-table" style="border-collapse: collapse !important;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                <tbody>
                  <tr>
                    <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      class="text-left semi-bold label-tag-left"
                      style="word-break:break-word"
                    >{{field.header_prop.doc_inv_tag.label}}</td>
                    <td :style="{'color':(field.temp_prop.font_color.hex||'#000')}" class="text-left label-tag-right" style="word-break:break-word">: {{ list.crdt_tags }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of third Block -->
            <div :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div>
            <!-- fourth Block -->
            <div class="invoice-fourth-block" style="display:flow-root" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
              <div
                class="invoice-address-block"
                style="display:flex;justify-content: space-between;word-break:break-word !important"
                :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
              >
                <!-- Bill Address -->
                <div
                  v-if="field.header_prop.doc_bill_to.show"
                  class="bill-address-block"
                  :style="{'border-right':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                >
                  <div
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                    style="padding:3px 8px;font-weight:500;background:#ebebeb;word-break:break-word"
                  >{{field.header_prop.doc_bill_to.label}}</div>
                  <div :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div>
                  <div
                    class="pl-8x"
                    :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                    style="margin-bottom:1px;font-weight:500;word-break:break-word"
                  >{{ list.header_details.cus_name }}</div>
                  <div class="custom-invoice-address pl-8x">
                    <p>{{ list.credit_details_address[1].cus_addr_line_1 }}</p>
                    <p>{{ list.credit_details_address[1].cus_addr_line_2 }}</p>
                    <p>{{ list.credit_details_address[1].cus_city }} {{ getDetails($AppDetails.state_details,list.credit_details_address[1].cus_state,'state_name') }}</p>

                    <p>{{ getDetails($AppDetails.country_details,list.credit_details_address[1].cus_country,'country_name') }} {{ list.credit_details_address[1].cus_pincode }}</p>
                    <p>{{ list.header_details.cus_mail }}</p>
                    <p>
                      <span>Ph:</span>
                      {{ list.header_details.cus_ph_no_1 }}
                    </p>
                    <p
                      v-if="(list.header_details.cus_gst_type != 3 && list.header_details.cus_gst_type != 5 && list.header_details.cus_gst_type != 6) && list.header_details.cus_gst_type != 0"
                    >
                      <span>GSTIN:</span>
                      {{ list.header_details.cus_gst_no }}
                    </p>
                  </div>
                </div>

                <div class="ship-address-block">
                  <!-- <div
                    style="padding:3px 8px ;font-weight:500;color:#000;background:#ebebeb"
                  >Credit Note</div>-->
                  <!-- <div :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div> -->
                  <table
                    class="custom-invoice-details-table"
                    style="margin-left: 5px;border-collapse: collapse !important;"
                    :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
                  >
                    <tbody>
                      <tr v-if="field.header_prop.doc_date.show">
                        <td
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                          class="text-left semi-bold right-label-left"
                          style="word-break:break-word"
                        >{{field.header_prop.doc_date.label}}</td>
                        <td
                      :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left right-label-right word-break"
                        > : {{getDateFormat(list.header_details.crdt_date)}}</td>
                      </tr>
                      <tr v-if="field.header_prop.doc_due_date.show">
                        <td
                        style="word-break:break-word"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                          class="text-left semi-bold right-label-left"
                        >{{field.header_prop.doc_due_date.label}}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left right-label-right word-break"
                        > : {{getDateFormat(list.header_details.created_date)}}</td>
                      </tr>
                      <tr>
                        <td style="word-break:break-word" class="text-left semi-bold" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">Invoice No.</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left right-label-right word-break"
                        > : {{ list.header_details.inv_no }}</td>
                      </tr>
                      <tr>
                        <td style="word-break:break-word" class="text-left semi-bold" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">Place of Supply</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left right-label-right word-break"
                        > : {{ getDetails($AppDetails.state_details,list.header_details.place_of_supply,'state_name') }} ({{ list.header_details.place_of_supply }})</td>
                      </tr>
                      <tr v-if="field.header_prop.doc_ref_no.show && list.header_details.ref_no != null && list.header_details.ref_no != ''">
                        <td style="word-break:break-word" class="text-left semi-bold" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.header_prop.doc_ref_no.label}}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left right-label-right word-break"
                        > : {{ list.header_details.ref_no }}</td>
                      </tr>
                      <tr v-if="field.header_prop.doc_sales_person.show" >
                        <td style="word-break:break-word" class="text-left semi-bold" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.header_prop.doc_sales_person.label}}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                          class="text-left right-label-right word-break"
                          style="word-break:break-word !important;margin-right:2px !important"
                        > : {{ list.header_details.sales_person_name }}</td>
                      </tr>
                      <tr
                        v-for="custom_field in crdt_settings_details.custom_field"
                        v-if="custom_field.print_show == 1 && custom_field.permissions != 'hide' && custom_field.status == 1 && list.header_details[custom_field.field_name]"
                        :key="custom_field.index"
                      >
                        <td style="word-break:break-word" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-left semi-bold left-label-left">{{custom_field.label_name}}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                         class="text-left left-label-right word-break"
                          v-if="custom_field.datatype == 'select'"
                          style="word-break:break-word !important"
                        > : {{ getJsonPresentValue(custom_field.options,'value',list.header_details[custom_field.field_name],'label') }}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left left-label-right word-break"
                          v-else-if="custom_field.datatype == 'date'"
                        > : {{ getDateFormat(list.header_details[custom_field.field_name]) }}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        style="word-break:break-word"
                          class="text-left left-label-right word-break"
                          v-else-if="custom_field.datatype == 'amount'"
                        > : {{ orgCurrencySymbol +' '+list.header_details[custom_field.field_name] }}</td>
                        <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                          class="text-left left-label-right word-break"
                          style="word-break:break-word !important"
                          v-else
                        > : {{ list.header_details[custom_field.field_name] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div v-if="field.header_prop.doc_inv_tag.show" :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'font-size':(field.temp_prop.font_size||8)+'pt'}"></div>
            <!-- End of Second Block -->
            <!-- Third Block-->
            <!-- <div
              v-if="field.header_prop.doc_inv_tag.show"
              class="invoice-third-block spreadsheet-layout-pad"
              style="margin:3px 0;"
            >
              <table class="custom-invoice-details-table" style="border-collapse: collapse !important;" >
                <tbody>
                  <tr>
                    <td class="text-left semi-bold label-tag-left">Credit tags</td>
                    <td
                      class="text-left label-tag-right"
                      style="word-break:break-word !important"
                    >{{ list.header_details.crdt_tags }}</td>
                  </tr>
                </tbody>
              </table>
            </div>-->
            <!-- End of third Block -->

            <!--End of fourth Block -->
            <!-- Fifth Block -->
            <div class="invoice-fifth-block">
              <table
              style="border-collapse: collapse !important;"
                class="custom-invoice-line-item-table"
                :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
              >
                <thead
                  class="semi-bold"
                  :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                >
                  <th
                  style="word-break:break-word"
                    :style="{'width':field.item_prop.label.item_no.width+'%'}"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.item_no.label}}</th>
                  <th
                  style="word-break:break-word"
                    :style="{'width':(field.item_prop.label.item.show?field.item_prop.label.item.width:field.item_prop.label.desc.width)+'%'}"
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left semi-bold"
                  >
                    <template
                      v-if="field.item_prop.label.item.show"
                    >{{field.item_prop.label.item.label+(field.item_prop.label.desc.show?field.item_prop.label.desc.label?(' & '+field.item_prop.label.desc.label):'& Description':'')}}</template>
                    <template v-else>{{field.item_prop.label.desc.label}}</template>
                  </th>
                   <th
                   style="word-break:break-word"
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  :style="{'width':field.item_prop.label.custom_field.width+'%'}"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                >{{custom.label_name}}</th>
                  <th
                  style="word-break:break-word"
                    :style="{'width':field.item_prop.label.hsn.width+'%'}"
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.hsn.label}}</th>
                  <th
                  style="word-break:break-word"
                    :style="{'width':field.item_prop.label.qty.width+'%'}"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.qty.label}}</th>
                  <th
                  style="word-break:break-word"
                    :style="{'width':field.item_prop.label.rate.width+'%'}"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.rate.label}}</th>
                  <th
                  style="word-break:break-word"
                    :style="{'width':field.item_prop.label.discount.width+'%'}"
                    v-if="field.item_prop.label.discount.show && 
                    list.header_details.discount_cat == 1"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.discount.label}}</th>
                   <th
                   style="word-break:break-word"
                    v-for="(tax_split,tax_index) in list.tax_split"
                  :style="{'width':(field.item_prop.label.tax.show?field.item_prop.label.tax.width:field.item_prop.label.tax_amt.width)+'%'}"
                  v-if="field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show"
                  class="text-right semi-bold"
                  :key="tax_index"
                >{{tax_split.tax_name}}</th>
                  <th
                  style="word-break:break-word;min-width:80px"
                    :style="{'width':field.item_prop.label.amt.width+'%'}"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right semi-bold"
                  >{{field.item_prop.label.amt.label}}</th>
                </thead>
                <tbody :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','color':(field.item_prop.layout.item_row_font_color.hex||'#000'),'background':(field.item_prop.layout.item_row_bg_color.show&&field.item_prop.layout.item_row_bg_color.value.hex||'#fff')}">
                  <tr v-for="(item,index) in list.credit_details_items" :key="index">
                    <td
                      v-if="field.item_prop.label.item_no.show"
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      style="vertical-align:top !important;word-break:break-word"
                    >{{ index + 1 }}</td>
                   <td
                      v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                      class="text-left"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >
                      <span v-if="field.item_prop.label.item.show"> {{ item.pdt_name }}</span>
                      <span
                      v-if="field.item_prop.label.desc.show"
                        :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                        style="display:block;word-break: break-word !important "
                      >{{ item.pdt_desc }}</span>
                      <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                        style="display:block;word-break: break-word !important"
                      >HSN/SAC Code : {{ item.pdt_hsn }}</span>
                    </td>
                    <td
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                  style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                >{{item[custom.field_name]}}</td>
                    <td
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    >{{ item.pdt_hsn }}</td>
                    <td
                      v-if="field.item_prop.label.qty.show"
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >
                      {{ item.pdt_qty }}
                      <span
                        style="word-break: break-word"
                        v-if="field.item_prop.label.qty.show_unit"
                      >{{ item.unit_name }}</span>
                    </td>
                    <td
                      v-if="field.item_prop.label.rate.show"
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >{{ parseFloat(item.unit_price) }}</td>
                    <td
                      v-if="field.item_prop.label.discount.show && list.header_details.discount_cat == 1"
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >{{ parseFloat(item.crdt_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                     v-for="(tax_split,tax_index) in item.tax_type_details"
                     :key="tax_index"
                    v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1&&list.header_details.inv_type!='2'"
                    style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  ><span  style="display:block"  v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show">{{tax_split.tax_amount?parseFloat(tax_split.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }):'-'}}</span>
                  <span v-if="field.item_prop.label.tax.show" :style="{'color':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"> {{ tax_split.value?item.tax_name != null ? parseFloat(tax_split.value)+'%' : '0%':'-' }}</span></td>
                   <td
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      v-if="field.item_prop.label.amt.show && list.header_details.tax_type_id == 1 && list.header_details.discount_cat == 1"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >{{ parseFloat(item.crdt_subtotal).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      v-else-if="field.item_prop.label.amt.show && list.header_details.tax_type_id == 2 && list.header_details.discount_cat == 1"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >{{ parseFloat(item.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                      :style="{'border':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                      v-else-if="field.item_prop.label.amt.show"
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                    >{{ parseFloat(item.crdt_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of Fifth Block -->

            <div
              :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
              class="invoice-total-block"
              style="display:flex"
            >
              <!-- Seventh Block -->
              
              <div
               style="min-height:50px"
                class="invoice-seventh-block total-words-left float-left"
                :style="{'font-size':(field.temp_prop.font_size||8)+'pt','position':field.total_prop.label.show_total_sec==1?'relative':'unset'}"
              >
               <div class="text-left semi-bold spreadsheet-layout-pad" 
              :style="{'font-size':(field.total_prop.layout.total_font_size||7)+'pt','color':field.total_prop.layout.total_font_color||'#000','background-color':field.total_prop.layout.total_font_color||'#000'}"
               v-if="field.total_prop.label.show_total_qty">
                <span :style="{'background':field.total_prop.layout.total_bg_color.value.hex}">{{field.total_prop.label.item_in_total}}</span>  : {{list.header_details.total_qty}}
               </div>
                <div
                  style="bottom:0;left:0;"
                  :style="{'position':field.total_prop.label.show_total_sec==1?'absolute':'unset'}"
                >
                  <div
                    v-if="list.header_details.is_tax_reverse_charge == 1"
                    class="text-left semi-bold mt-1 spreadsheet-layout-pad"
                  >
                    Amount of tax subject to Reverse charge:
                    <span
                      class="fw-semi-bold"
                    ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.header_details.crdt_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </div>
                  <div
                    v-if="field.total_prop.label.show_amt_wrd"
                    class="text-left semi-bold spreadsheet-layout-pad"
                  >Total Amount (in words) : {{ total_in_words+" Only" }}</div>
                </div>
              </div>
              <!-- End of seventh block -->
              <!-- Sixth Block -->
              <!-- Subtotal,total -->
              <!-- Tax,Discount -->
              <!-- Balance Due -->
              <div
                v-if="field.total_prop.label.show_total_sec"
                class="invoice-sixth-block total-right float-right"
                style="margin-left:-1px;position:relative"
                :style="{'border-left':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt','color':field.total_prop.layout.total_font_color||'#000','background-color':field.total_prop.layout.total_font_color||'#000'}"
              >
                <table class="custom-invoice-total-table" style="border-collapse: collapse !important;width:100%" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
                  <tbody style="background:#fff">
                    <tr v-if="field.total_prop.label.sub_total.show">
                      <td
                        class="text-right semi-bold"
                        style="word-break:break-word"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      >
                  <span class="float-right">{{field.total_prop.label.sub_total.label+(list.header_details.tax_type_id == 1?'(Tax Inclusive)':'')}}</span></td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        v-if="list.header_details.tax_type_id == 1 && list.header_details.discount_cat == 1"
                        
                      >{{ parseFloat(parseFloat(list.header_details.total_credit_amount) - parseFloat(list.header_details.adjusted_amount)).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        v-else-if="list.header_details.tax_type_id == 2 && list.header_details.discount_cat == 1"
                        
                      >{{ parseFloat(list.header_details.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        v-else-if="list.header_details.discount_cat != 1"
                        
                      >{{ parseFloat(list.header_details.total_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </tr>
                    <template
                      v-if="list.header_details.discount_cat == 3 && list.header_details.is_tax_reverse_charge == 0"
                    >
                      <tr v-for="taxlist in splitted_tax" v-if="taxlist != null" :key="taxlist.id">
                        <td
                        style="word-break:break-word"
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          
                        >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</td>
                        <td
                        style="width:150px;word-break:break-word"
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          
                        ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </tr>
                    </template>
                    <tr v-if="field.total_prop.label.show_discount">
                      <td
                      style="word-break:break-word"
                        class="text-right"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      >Discount</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      >(-){{ parseFloat(list.header_details.crdt_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </tr>
                    <template
                      v-if="list.header_details.discount_cat != 3  && list.header_details.is_tax_reverse_charge == 0"
                    >
                      <tr v-for="taxlist in splitted_tax" v-if="taxlist != null" :key="taxlist.id">
                        <td
                        style="word-break:break-word"
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          
                        >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</td>
                        <td
                        style="width:150px;word-break:break-word"
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          
                        ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </tr>
                    </template>
                    <tr
                      v-if="field.total_prop.label.show_pay_detail&&list.header_details.shipping_amount > 0&&list.header_details.is_shipping_charge&&field.total_prop.label.shipping_charge  "
                    >
                      <td
                      style="word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      >{{field.total_prop.label.shipping_charge}}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(list.header_details.shipping_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </tr>
                    <tr v-if="list.header_details.adjusted_amount != 0 &&field.total_prop.label.show_pay_detail">
                      <td
                      style="word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      >{{list.header_details.adjustment_name}}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.header_details.adjusted_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </tr>
                    <tr>
                       <template v-if="field.total_prop.label.show_pay_detail">
                      <td
                      style="word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      >{{field.total_prop.label.total}}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                        
                      ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.header_details.total_credit_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                       </template>
                       <template v-else>
                      <td
                      style="word-break:break-word"
                        class="text-right semi-bold"
:style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"                        
                      >{{field.total_prop.label.total}}</td>
                      <td
                      style="width:150px;word-break:break-word"
                        class="text-right semi-bold"
:style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"                        
                      ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{parseFloat(list.header_details.total_credit_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </template>
                    </tr>
                    <template v-if="field.total_prop.label.show_pay_detail">
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          style="font-style:italic;word-break:break-word"
                        >{{field.total_prop.label.pay_made}}</td>
                        <td
                          class="text-right text-danger"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex}"
                          style="font-style:italic;width:150px;word-break:break-word;color:#f55d5d!important"
                        ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{'(-) '+parseFloat(list.header_details.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </tr>
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                          style="font-style:italic;word-break:break-word"
                        >{{field.total_prop.label.credits_apply}}</td>
                        <td
                          class="text-right text-danger"
                          :style="{'background':field.total_prop.layout.total_bg_color.value.hex}"
                          style="font-style:italic;width:150px;word-break:break-word;color:#f55d5d!important"
                        ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{'(-) '+parseFloat(list.header_details.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </tr>
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          style="font-style:italic;word-break:break-word"
                          :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                        >{{field.total_prop.label.bal_due}}</td>
                        <td
                          class="text-right"
                          style="font-style:italic;width:150px;word-break:break-word"
                          :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                        ><span :class="{'float-right':field.total_prop.label.currency_syb==2}"> {{currency_symbol}} </span>{{'(-) '+parseFloat(list.header_details.available_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <!-- End of sixth block -->
            </div>

            <div :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div>
            <div class="text-right spreadsheet-layout-pad" style="padding-top: 2px;" :style="{'font-size':6+'pt'}" >
              <i>E. & O.E</i>
            </div>
            <!-- eight Block -->
            <div
              v-if="field.footer_prop.show_term_con"
              class="invoice-eight-block spreadsheet-layout-pad"
              :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
            >
              <div
                class="terms-conditions"
                :style="{'font-size':field.footer_prop.term_font_size+'pt'}"
              >
                <div :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="semi-bold text-left">{{field.footer_prop.term_label}}</div>
                <div
                  style="word-break: break-word;white-space: pre;"
                >{{ list.header_details.crdt_terms_cndtn }}</div>
              </div>
            </div>
            <!--End of eight Block -->
            <div :style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"></div>

            <!-- ninth Block  -->
            <div class="invoice-ninth-block spreadsheet-layout-pad" style="display: flow-root;" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
              <div class="signature-block">
                <div style="float:right;width:max-content" v-if="field.footer_prop.signature.show">
                  <div class="semi-bold text-right mb-2" style="word-break:break-word" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{field.footer_prop.signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:5px;margin-top: 1.5rem"  />
                  <div
                    class="text-left"
                  >{{field.footer_prop.signature.name}}</div>
                </div>
            </div>
            </div>
            <!--End of  ninth Block  -->

            <!-- Tenth Block -->
            <div class="invoice-tenth-block spreadsheet-layout-pad" :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">
              <div
                class="invoice-notes"
                style="margin-bottom:0.1in;word-break:break-word !important"
              >
               <div :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" class="text-center">{{field.footer_prop.note_label||''}}</div>
                <div
                  :style="{'font-size':field.footer_prop.note_font_size+'pt'}"
                  class="text-center"
                >{{ crdt_settings_details.cus_inv_notes }}</div>
              </div>
            </div>
            <!-- End of Tenth Block -->
          </div>
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.footer_color.hex||'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 SPREADSHEET (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { number_to_words } from "@/mixins/NumberToWords";
export default {
  props: ["list", "printlabel", "showprintlabel"],
  data() {
    return {
      total_in_words: "",
      imageSrc: "",
      tax_list: "",
      currency_symbol: "",
      splitted_tax: []
    };
  },
  created() {
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.header_details.total_credit_amount,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.header_details.cus_currency,
          "currency_code_fraction"
        )
      );
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
  },
  methods: {
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][0][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    }
  },
  mounted() {
    //    customer currency symbol
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.header_details.cus_currency,
      "currency_symbol"
    );
    var splitted_tax_percent = [];
    var tax_on_taxable_amount = [];
    this.splitted_tax = [];
    this.list.credit_details_items.reduce((total, value) => {
      var tax_id =
        !isNaN(value.crdt_tax_id) && value.crdt_tax_id != ""
          ? parseFloat(value.crdt_tax_id)
          : 0;
      // <!-----------------------------------dynamic tax calculation based on tax group------------------------------------------>
      if (!isNaN(tax_id) && tax_id != 0) {
        var tax_ids = value.tax_ids ? value.tax_ids.split(",") : "";

        if (tax_ids != "" && tax_ids != null && typeof tax_ids != "undefined") {
          for (var i = 0; i < tax_ids.length; i++) {
            if (
              this.list.tax_list[value.crdt_itm_id][i].tax_amount != null &&
              typeof this.list.tax_list[value.crdt_itm_id][i].tax_amount !=
                "undefined" &&
              !isNaN(this.list.tax_list[value.crdt_itm_id][i].tax_amount)
            ) {
              splitted_tax_percent[tax_ids[i]] = !isNaN(
                splitted_tax_percent[tax_ids[i]]
              )
                ? parseFloat(splitted_tax_percent[tax_ids[i]]) +
                  parseFloat(
                    this.list.tax_list[value.crdt_itm_id][i].tax_amount
                  )
                : parseFloat(
                    this.list.tax_list[value.crdt_itm_id][i].tax_amount
                  );
              tax_on_taxable_amount[tax_ids[i]] = !isNaN(
                tax_on_taxable_amount[tax_ids[i]]
              )
                ? parseFloat(tax_on_taxable_amount[tax_ids[i]]) +
                  parseFloat(value.subtotal_without_tax)
                : parseFloat(value.subtotal_without_tax);
            }
            //  update splitted tax variable
            var hasMatch = this.getIndexValue(
              this.splitted_tax,
              "id",
              tax_ids[i]
            );
            var tax_details = [
              {
                id: tax_ids[i],
                label:
                  this.list.tax_main[tax_ids[i]].tax_name +
                  "[" +
                  parseFloat(this.list.tax_list[value.crdt_itm_id][i].value) +
                  "%]",
                value: splitted_tax_percent[tax_ids[i]],
                taxable: parseFloat(tax_on_taxable_amount[tax_ids[i]]).toFixed(
                  2
                )
              }
            ];
            if (!isNaN(parseInt(hasMatch))) {
              this.splitted_tax[hasMatch] = tax_details;
            } else {
              this.splitted_tax.push(tax_details);
            }
          }
        }
      }
      return;
    }, 0);
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      field: state =>
        state.permission.print_settings_details["Credit Note"].template_list,
      credit_details: state => state.credit.details
    }),
    ...mapGetters(["org_details", "crdt_settings_details", "orgCurrencySymbol","pdt_settings_details"])
  }
};
</script>


 <style lang="scss" scoped>
.clearfix:after,
.clearfix:before {
  content: " ";
  display: table;
}
.ribbon {
  position: absolute !important;
  top: -4px;
  left: -5px;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
td.labels,
td.values {
  padding: 0px !important;
}
.ribbon .ribbon-inner {
  font-size: 13px;
  text-align: center;
  color: #fff;
  top: 34px;
  left: -35px;
  width: 166px;
  padding: 4px;
  position: relative;
  transform: rotate(-45deg);
}
.ribbon .ribbon-inner:before {
  left: 0;
  border-left: 2px solid transparent;
}
.ribbon .ribbon-inner:after {
  right: -2px;
  border-bottom: 3px solid transparent;
}
.ribbon .ribbon-inner:after,
.ribbon .ribbon-inner:before {
  content: "";
  border-top: 5px solid transparent;
  border-left: 5px solid;
  border-left-color: inherit;
  border-right: 5px solid transparent;
  border-bottom: 5px solid;
  border-bottom-color: inherit;
  position: absolute;
  top: 20px;
  transform: rotate(-45deg);
}
@page {
  size: A4;
  margin: 0;
}

div.a4-size {
  margin: 0;
}

div.a4-size .a4-sheet {
  width: 210mm;
  min-height: 100%;
}

div.letter .a4-sheet {
  width: 216mm;
  height: 279mm;
}

/** Padding area **/
.a4-sheet {
  padding: 10mm;
}

/** For screen preview **/
@media screen {
  div.a4-size {
    background: #fff;
  }

  .a4-sheet {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin: 5mm auto;
  }
}
@media screen and (max-width: 1030px) {
  div.a4-size .a4-sheet {
    width: 201mm;
    min-height: 100%;
  }
}
@media screen and (max-width: 1000px) {
  div.a4-size .a4-sheet {
    width: 177mm;
    min-height: 100%;
  }
  .a4-size .title {
    font-size: 20px !important;
  }
}
@media print {
  div.a4-size {
    width: 210mm;
    height: 297mm;
    font-size: 13px;
    page-break-inside: avoid;
  }
}

.a4-size .invoice-details {
  font-size: 14px;
}

.a4-size .table1 table {
  border-collapse: collapse;
  width: 100%;
  padding-top: 15 px;
  padding-top: 3px;
  border-color: #c3c3c3;
}

.a4-size .table1 td,
.a4-size th {
  border: 1px solid #c3c3c3;
  text-align: left;
  padding: 8px;
}

.a4-size .invoice-terms-column {
  height: 90px;
  border: 1px solid #c3c3c3;
  padding: 5px 5px;
}

.a4-size .heading {
  text-align: center;
  font-family: saira-font;
  padding-top: 0px;
  margin-top: 0px;
}

.a4-size .address {
  font-style: initial;
  font-size: 12px;
  line-height: 0.5;
  padding-top: 5px;
}
.a4-size .address p {
  margin-top: 12px;
}

.a4-size .sign {
  float: left;
  padding-left: 5px;
  margin-top: 75px;
}

.a4-size .authored-sign {
  float: right;
  margin-top: 55px;
  padding-right: 5px;
}

.a4-size .header-address {
  margin-left: 8px;
  font-style: initial;
  font-size: 14px;
  line-height: 0.5;
  padding-top: 5px;
}

.a4-size .label {
  width: 45%;
  display: inline-block;
  /* vertical-align: top; */
  font-size: 12px;
}

.a4-size .values {
  padding-top: 4px;
  padding-bottom: 5px;
  font-size: 12px;
  float: right;
  /* text-align: right; */
}
.a4-size .table1 table thead tr {
  border-top: 1px solid #c3c3c3 !important;
}
.a4-size .labels {
  /* width: 45%;
  padding-left: 138px; */
  padding-top: 4px;
  padding-bottom: 5px;
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
}

.a4-size .label1 {
  width: 100%;
  display: inline-block;
  vertical-align: top;
}

.value {
  /* font-weight: 600; */
  font-size: 12px;
}

.a4-size p {
  font-size: 12px;
}

.a4-size .img {
  max-width: 120px;
  max-height: 120px;
  float: left;
  padding-right: 5px;
  padding-bottom: 5px;
  /* margin-top: -150px; */
}

.a4-size .title {
  float: right;
  margin-top: -86px;
  font-size: 25px;
  padding-right: 10px;
}

.inv-no {
  float: right;
  margin-top: -46px;
  font-size: 15px;
  padding-right: 10px;
}

.a4-size table {
  border-spacing: 0;
}

.a4-size .inv-details {
  border-right: 1px solid #c3c3c3;
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 64%;
}

.a4-size .inv-details2 {
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 36%;
}

.a4-size .detail {
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #c3c3c3;
}

.a4-size .detail thead {
  background-color: #efeded;
}

.a4-size .bill {
  width: 50%;
  border-left: none;
  font-size: 12px;
}

.a4-size .ship {
  width: 50%;
  border-right: none;
  font-size: 12px;
}

.a4-size .detail tbody td {
  border-right: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
}

.a4-size .table1 table thead {
  border-left: none;
  border-right: none;
  font-size: 12px;
}

.a4-size .end td {
  /* border-top: 1px solid #c3c3c3; */
  width: 100%;
}

.a4-size .seal td {
  border-top: 1px solid #c3c3c3;
  border-bottom: none;
  width: 1200px;
}

.a4-size .table-details {
  width: 100%;
  margin-top: -1px;
}

.a4-size .table-details table {
  border-spacing: 0;
}

.a4-size .total {
  border-right: 1px solid #c3c3c3;
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 50%;
}

.a4-size .calc {
  border-top: 1px solid #c3c3c3;
  padding: 3px 0;
  width: 50%;
}

.table1.item-line th {
  padding: 5px !important;
}
.text-sm {
  font-size: 12px !important;
}
.table1.item-line td:last-child {
  border-right: 0 !important;
}
.amt_words_block {
  position: relative !important;
}

.amt_words {
  position: absolute !important;
  bottom: 0 !important;
}
.label.label-left {
  width: 24% !important;
}
.invoice_tag_block {
  margin-bottom: 5px !important;
  margin-top: 5px !important;
  margin-left: 8px !important;
}
table.end {
  border-top: 1px solid #c3c3c3 !important;
  width: 100%;
}
.invoice_block {
  outline: 1px solid #c3c3c3;
}
.display-block {
  display: block !important;
}

/* // A4 STANDARD PORTRAIT CSS */
/* // Bootstrap class */
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
/* //Custom css */
/* //A4 spreadsheet portrait */
#a4-spreadsheet-portrait-page {
  width: 21cm;
  min-height: 29.7cm;
}
/* //A4 spreadsheet landscape */
#a4-spreadsheet-landscape-page {
  width: 29.7cm;
  min-height: 21cm;
}
/* //A5 standard landscape */
#a5-spreadsheet-portrait-page {
  width: 14.8cm;
  min-height: 21cm;
}
/* //A5 spreadsheet landscape */
#a5-spreadsheet-landscape-page {
  width: 21cm;
  min-height: 14.8cm;
}
#a4-spreadsheet-portrait-page .print-template {
  zoom: 115%;
}
#a5-spreadsheet-landscape-page .print-template {
  zoom: 78%;
}
#a4-spreadsheet-landscape-page .invoice-content-layout {
  zoom: 110%;
}
.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}

table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}

table.custom-invoice-total-table > tbody > tr > td {
  padding: 2px 8px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table tbody > tr > td,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}

table.shipping-details-table td {
  border: 1px solid #c3c3c3;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}

table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;

  padding-bottom: 10px;
}
.invoice-details-block-right {
  width: 50%;
}
.invoice-details-block-left {
  width: 50%;
}
.left-label-left {
  width: 50%;
}
.left-label-right {
  width: 50%;
}
.right-label-left {
  width: 50%;
}
.right-label-right {
  width: 50%;
}
table.custom-invoice-details-table,
.invoice-address-block,
.invoice-total-block {
  width: 100%;
}
.label-tag-left {
  width: 15%;
}
.label-tag-right {
  width: 85%;
}

.bill-address-block,
.ship-address-block,
.total-right,
.total-words-left {
  width: 50%;
}
.pl-8x {
  padding-left: 8px;
}
.invoice-notes {
  margin-top: 15px;
}
.spreadsheet-layout-pad {
  padding: 0 0.1in;
}

table.custom-invoice-line-item-table > tbody > tr > td:first-child {
  border-left: 0 !important;
}

table.custom-invoice-line-item-table > tbody > tr > td:last-child {
  border-right: 0 !important;
}

#a5-spreadsheet-portrait-page .left-label-left {
  width: 35%;
}
#a4-spreadsheet-portrait-page .left-label-left {
  width: 28%;
}
#a4-spreadsheet-landscape-page .invoice-details-block-left {
  width: 75%;
}
#a4-spreadsheet-landscape-page .invoice-details-block-right {
  width: 25%;
}
#a4-spreadsheet-landscape-page .left-label-left {
  width: 15%;
}
#a4-spreadsheet-landscape-page .label-tag-left {
  width: 12%;
}

@media (min-width: 10px) and (max-width: 768px) {
  .responsive-print {
    zoom: 51%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .responsive-print {
    zoom: 70%;
  }
}
</style>